import React from 'react';

import SorryMessage from './sorry-message';
import Chat from './chat';
import Support from './support';

import { StyledSection, StyledSectionInner } from './styles';

const NoResults = () => {
  return (
    <StyledSection primary>
      <StyledSectionInner>
        <SorryMessage />
        <Chat />
        <Support />
      </StyledSectionInner>
    </StyledSection>
  );
};

export default NoResults;